import { GenericDrawer } from '@/components'
import { ChangeLogIsolve } from '@/models'
import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'
import { VChip, VTimeline, VTimelineItem, VContainer } from 'vuetify/lib'

import './Timeline.scss'
import { GuardianService } from '@/services'
import { DateTime } from 'luxon'

import { CaptureEvent, Events } from '@/services/AmplitudeService'

@Component({})
export class ChangeLogTimeline extends Vue {
	changeLogList: Array<ChangeLogIsolve> = new Array<ChangeLogIsolve>()

	async beforeMount() {
		let responseChangeLogs = await GuardianService.getChangelogList(10)

		this.changeLogList = responseChangeLogs.result.filter((changeLog) => changeLog.publishedAt)
	}

	public render() {
		return (
			<div>
				<GenericDrawer
					title="Últimas atualizações do sistema"
					ref="drawer"
					scopedSlots={{
						default: () => this.renderTimeLine()
					}}
				/>
			</div>
		)
	}

	private renderTimeLine() {
		return (
			<VContainer id="timeline-changelog" class="py-4 px-7">
				<div class="timeline-holder">
					<VTimeline dense alignTop class="py-0 mt-4">
						{this.changeLogList.map(this.renderTimeLineItems)}
					</VTimeline>
				</div>
			</VContainer>
		)
	}

	/**
	 * Render timeline items
	 * @param item
	 * @param index
	 * @returns TODO
	 */
	private renderTimeLineItems(item: ChangeLogIsolve, index: number) {
		return (
			<VTimelineItem
				class="pb-4 pr-3 mb-4"
				key={item.id}
				right
				fillDot
				small
				icon={index == 0 ? 'mdi-map-marker-outline' : 'mdi-check'}
				iconColor="#252524"
				color="#F8F9F5"
			>
				<div>
					<strong>
						{item.title} ({DateTime.fromISO(item.publishedAt).toFormat('dd-MM-yyyy')})
						{index == 0 && (
							<VChip color="#FFF8E6" textColor="#000" small>
								Mais recente
							</VChip>
						)}
					</strong>{' '}
					<br />
					<div
						//@ts-ignore
						domPropsInnerHTML={item.description}
					></div>
				</div>
			</VTimelineItem>
		)
	}

	openDrawer() {
		const drawer = this.$refs.drawer as GenericDrawer

		CaptureEvent(Events.ChangeLogView)

		drawer.openDrawer()
	}
}

export default ChangeLogTimeline
